import { css } from '@emotion/react'
import { useCallback } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { draggableDots as Dots } from 'assets/icons/groove/v2'
import { Tooltip } from 'shared/ui'
import { Button, Icon, Input, Radio } from 'util/ui'

const handleCss = css`
  font-size: 19px;
  margin: -5px -3px;
  cursor: grab;
  .dragging & {
    cursor: grabbing;
    pointer-events: all !important;
  }
`
const rowCss = css`
  display: flex;
  z-index: 100000;
  margin-bottom: 8px;
  .fluid {
    flex-grow: 1;
  }

  &&& .RemoveButton {
    margin-left: 8px;
    line-height: 30px;
    width: 43px;
  }
`

const DragHandle = props => <Dots css={handleCss} {...props} />

export default function ArrayOfStringsItem({
  doSetRecord,
  doSetPrimary,
  doRemove,
  index,
  isPrimary,
  primary,
  noun,
  name,
  sortable,
  value,
}) {
  const onCheckbox = useCallback(() => doSetPrimary(index), [
    index,
    doSetPrimary,
  ])
  const onChange = useCallback(
    ({ target: { value: newValue = '' } = {} }) => {
      doSetRecord(index, newValue)
    },
    [index, doSetRecord]
  )
  const onRemove = useCallback(
    e => {
      e.preventDefault()
      if (doRemove) doRemove(index)
    },
    [index, doRemove]
  )

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ disabled: !sortable, id: `${index}` })
  const style = sortable
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
      }
    : undefined
  return (
    <div ref={setNodeRef} style={style} css={rowCss} className={'sui'}>
      <Input
        fluid
        label={
          (primary || sortable) && {
            basic: true,
            content: [
              primary && (
                <Tooltip
                  key="primary"
                  position="left"
                  tooltip={`Select as primary ${noun}`}
                >
                  <Radio checked={isPrimary} onClick={onCheckbox} />
                </Tooltip>
              ),
              sortable && (
                <DragHandle key="dragHandle" {...attributes} {...listeners} />
              ),
            ],
          }
        }
        name={`${name}.content`}
        onChange={onChange}
        value={value || ''}
      />
      <Button
        as="div"
        className="RemoveButton"
        disabled={!doRemove}
        basic
        icon
        onClick={onRemove}
      >
        <Icon name="trash alternate outline" />
      </Button>
    </div>
  )
}
